module.exports = __webpack_public_path__ + "img/login.6967d246.png";